var render, staticRenderFns
import script from "./dataRange.vue?vue&type=script&lang=js"
export * from "./dataRange.vue?vue&type=script&lang=js"
import style0 from "./dataRange.vue?vue&type=style&index=0&id=55ab1297&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../base/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ab1297",
  null
  
)

export default component.exports